import { render, staticRenderFns } from "./WebRatingCustomizationSection.vue?vue&type=template&id=4649556e&scoped=true&"
import script from "./WebRatingCustomizationSection.vue?vue&type=script&lang=js&"
export * from "./WebRatingCustomizationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4649556e",
  null
  
)

export default component.exports